import React, { useEffect } from 'react'
import PortfolioSection from '../../sections/PortfolioSection'

const Portfolio = () => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <PortfolioSection />

    )
}

export default Portfolio